export const mxSubdomainValidator = (value) => {
    if (!value || value === '@') return true;

    const regex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(value) ? true : "validate.mx_subdomain_format";
}; 